import { ERequestApiStatus, EWsClientEventType } from '../../types/appState';
import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EWsAnswerActionTypes {
  SendPending = 'chat/wsAnswer/sendPending',
  SendSucceed = 'chat/wsAnswer/sendSucceed',
  SendFailed = 'chat/wsAnswer/sendFailed',
}

export type TWsAnswerActions =
  | ITypedReduxAction<EWsAnswerActionTypes.SendPending, void>
  | ITypedReduxAction<EWsAnswerActionTypes.SendSucceed, void>
  | ITypedReduxAction<EWsAnswerActionTypes.SendFailed, void>;

export interface IAnswerEvent {
  type: EWsClientEventType.Answer;
  status: ERequestApiStatus;
}

export interface IWsAnswerEvent {
  uid: string;
  type: EWsClientEventType.Answer;
  userId: number;
  message: {
    messageId: string;
    payload: string;
    input?: string;
  };
}
